import { useLoaderData } from "react-router-dom";
import { WeblinkHandler } from "../components/weblink-handler";

export function WeblinkPage(props) {
  const { appName, appAddress } = props;
  const order = useLoaderData();
  return (
    <WeblinkHandler order={order} appName={appName} appAddress={appAddress} />
  );
}
